import './FormRecordHeader.scss';

import { DateField } from '@refinedev/antd';
import { Flex } from 'antd';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Encabezado genérico para formularios en modo edición que muestra
 * ID del registro, tag de estado, fechas de creación/modificación y slots adicionales.
 *
 * metadata:
 * - feature: forms.record-header
 * - purpose: reemplaza el bloque repetido de ID + estado + fechas en ShipmentForm, ReceptionForm y ServiceOrderForm
 */
interface FormRecordHeaderProps {
  /** ID del registro */
  id: number | string;
  /** Label descriptivo del tipo de registro (ej: "Id de envío", "Id de recepción") */
  label: string;
  /** Tag de estado u otro indicador visual */
  statusTag?: ReactNode;
  /** Fecha de creación ISO */
  createdAt?: string;
  /** Fecha de última modificación ISO */
  updatedAt?: string;
  /** Contenido adicional junto al tag de estado */
  extraTags?: ReactNode;
  /** Contenido adicional junto a las fechas */
  extraInfo?: ReactNode;
  /** Clase CSS del contenedor */
  className?: string;
}

const FormRecordHeader = ({
  id,
  label,
  statusTag,
  createdAt,
  updatedAt,
  extraTags,
  extraInfo,
  className = 'FormRecordHeader',
}: FormRecordHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <div>
        <div className={`${className}Id`}>
          {label}: {id}
        </div>
        <Flex>
          {statusTag}
          {extraTags}
        </Flex>
      </div>
      <div>
        {createdAt && (
          <div>
            <b>{t('Fecha de creación')}: </b>
            <DateField value={createdAt} />
          </div>
        )}
        {updatedAt && (
          <div>
            <b>{t('Fecha última modificación')}: </b>
            <DateField value={updatedAt} />
          </div>
        )}
        {extraInfo}
      </div>
    </div>
  );
};

export default FormRecordHeader;
